import React from "react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {LaboratoryShowcaseWrapperBox} from "./boxes/laboratory-showcase-wrapper.box";
import {ButtonsShowcase} from "./buttons-showcase.component";
import {MediaQueryShowcase} from "./media-query-showcase.component";
import {IconsShowcase} from "./icons-showcase.component";
import {ClientHintsShowcase} from "./client-hints-showcase.component";
import {PopoupsShowcase} from "./popups-showcase.component";
import {BurnoutAnimationShowcase} from "./burnout-animation-showcase.component";
import {PixiSpineShowcase} from "./pixi-spine-showcase.component";
import {OnboardingTourShowcase} from "./onboarding-tour-showcase.component";
import {ThemeSwitcher} from "./theme-switcher.component";
import {TypographyColorAndPresetShowcase} from "./typography-color-and-preset-showcase.component";
import {GamblingSessionSetupDialogShowcase} from "./gambling-session-setup-dialog-showcase.component";
import {GeoLocationBrowserApiTestComponent} from "./geo-location-browser-api-test.component";
import {ToasterShowcase} from "./toaster-showcase.component";

export class LaboratoryShowcase extends OrbitComponent {

    render() {
        return <LaboratoryShowcaseWrapperBox>

            <GeoLocationBrowserApiTestComponent/>

            <ToasterShowcase />


            <GamblingSessionSetupDialogShowcase />

            <OnboardingTourShowcase />

            <div style={{height: "30px"}}></div>

            <BurnoutAnimationShowcase />

            <div style={{height: "30px"}}></div>

            <PixiSpineShowcase />

            <div style={{height: "30px"}}></div>

            <ThemeSwitcher>
                <ButtonsShowcase />
            </ThemeSwitcher>

            <div style={{height: "30px"}}></div>

            <ThemeSwitcher>
                <TypographyColorAndPresetShowcase />
            </ThemeSwitcher>

            <PopoupsShowcase />

            <div style={{height: "30px"}}></div>

            <IconsShowcase />

            <div style={{height: "30px"}}></div>

            <MediaQueryShowcase />

            <div style={{height: "30px"}}></div>

            <ClientHintsShowcase />
        </LaboratoryShowcaseWrapperBox>;
    }

}
